var map = {
	"./de/discover.json": [
		24734,
		9525
	],
	"./de/misc.json": [
		18208,
		6823
	],
	"./de/news.json": [
		75019,
		8729
	],
	"./de/page.companyReport.dividend.json": [
		26735,
		9687
	],
	"./de/page.companyReport.future.json": [
		11525,
		8534
	],
	"./de/page.companyReport.health.json": [
		32702,
		6066
	],
	"./de/page.companyReport.information.json": [
		79821,
		3516
	],
	"./de/page.companyReport.json": [
		42723,
		4895
	],
	"./de/page.companyReport.management.json": [
		79413,
		1084
	],
	"./de/page.companyReport.overview.json": [
		71764,
		8875
	],
	"./de/page.companyReport.ownership.json": [
		81296,
		3229
	],
	"./de/page.companyReport.past.json": [
		93507,
		1029
	],
	"./de/page.companyReport.valuation.json": [
		71020,
		8698
	],
	"./de/page.discover.json": [
		24125,
		9525
	],
	"./de/page.stocks.json": [
		66833,
		9525
	],
	"./de/statementGlossary.json": [
		76007,
		6007
	],
	"./de/web.json": [
		53343,
		3343
	],
	"./en/discover.json": [
		8534,
		9525
	],
	"./en/misc.json": [
		466,
		6823
	],
	"./en/news.json": [
		90818,
		7479
	],
	"./en/page.companyReport.dividend.json": [
		54825,
		9687
	],
	"./en/page.companyReport.future.json": [
		44378,
		8534
	],
	"./en/page.companyReport.health.json": [
		7200,
		6066
	],
	"./en/page.companyReport.information.json": [
		11582,
		3516
	],
	"./en/page.companyReport.json": [
		51889,
		2487
	],
	"./en/page.companyReport.management.json": [
		68574,
		1084
	],
	"./en/page.companyReport.overview.json": [
		75912,
		8875
	],
	"./en/page.companyReport.ownership.json": [
		99900,
		3229
	],
	"./en/page.companyReport.past.json": [
		56723,
		1029
	],
	"./en/page.companyReport.valuation.json": [
		39421,
		8698
	],
	"./en/page.discover.json": [
		3350,
		9525
	],
	"./en/page.stocks.json": [
		23454,
		9525
	],
	"./en/statementGlossary.json": [
		22479,
		2479
	],
	"./en/web.json": [
		75339,
		5339
	],
	"./es/discover.json": [
		30775,
		9525
	],
	"./es/misc.json": [
		41786,
		6823
	],
	"./es/news.json": [
		83156,
		8054
	],
	"./es/page.companyReport.dividend.json": [
		10117,
		9687
	],
	"./es/page.companyReport.future.json": [
		13223,
		8534
	],
	"./es/page.companyReport.health.json": [
		94804,
		6066
	],
	"./es/page.companyReport.information.json": [
		32862,
		3516
	],
	"./es/page.companyReport.json": [
		30186,
		8996
	],
	"./es/page.companyReport.management.json": [
		92851,
		1084
	],
	"./es/page.companyReport.overview.json": [
		89697,
		8875
	],
	"./es/page.companyReport.ownership.json": [
		35027,
		3229
	],
	"./es/page.companyReport.past.json": [
		88754,
		1029
	],
	"./es/page.companyReport.valuation.json": [
		15860,
		8698
	],
	"./es/page.discover.json": [
		40728,
		9525
	],
	"./es/page.stocks.json": [
		23016,
		9525
	],
	"./es/statementGlossary.json": [
		6924,
		6924
	],
	"./es/web.json": [
		6476,
		6476
	],
	"./fr/discover.json": [
		63588,
		9525
	],
	"./fr/misc.json": [
		26388,
		6823
	],
	"./fr/news.json": [
		94743,
		3431
	],
	"./fr/page.companyReport.dividend.json": [
		73837,
		9687
	],
	"./fr/page.companyReport.future.json": [
		43448,
		8534
	],
	"./fr/page.companyReport.health.json": [
		21155,
		6066
	],
	"./fr/page.companyReport.information.json": [
		25662,
		3516
	],
	"./fr/page.companyReport.json": [
		92002,
		1928
	],
	"./fr/page.companyReport.management.json": [
		27949,
		1084
	],
	"./fr/page.companyReport.overview.json": [
		49946,
		8875
	],
	"./fr/page.companyReport.ownership.json": [
		44885,
		3229
	],
	"./fr/page.companyReport.past.json": [
		71048,
		1029
	],
	"./fr/page.companyReport.valuation.json": [
		52950,
		8698
	],
	"./fr/page.discover.json": [
		1863,
		9525
	],
	"./fr/page.stocks.json": [
		48401,
		9525
	],
	"./fr/statementGlossary.json": [
		96478,
		6478
	],
	"./fr/web.json": [
		25471,
		5471
	],
	"./it/discover.json": [
		4766,
		9525
	],
	"./it/misc.json": [
		59516,
		9951
	],
	"./it/news.json": [
		97035,
		8729
	],
	"./it/page.companyReport.dividend.json": [
		95053,
		9687
	],
	"./it/page.companyReport.future.json": [
		53738,
		8534
	],
	"./it/page.companyReport.health.json": [
		17869,
		6066
	],
	"./it/page.companyReport.information.json": [
		55855,
		3516
	],
	"./it/page.companyReport.json": [
		68676,
		2110
	],
	"./it/page.companyReport.management.json": [
		19833,
		1084
	],
	"./it/page.companyReport.overview.json": [
		13576,
		8875
	],
	"./it/page.companyReport.ownership.json": [
		33415,
		3229
	],
	"./it/page.companyReport.past.json": [
		53474,
		1029
	],
	"./it/page.companyReport.valuation.json": [
		72912,
		8698
	],
	"./it/page.discover.json": [
		50332,
		9525
	],
	"./it/page.stocks.json": [
		30277,
		9525
	],
	"./it/statementGlossary.json": [
		81777,
		1777
	],
	"./it/web.json": [
		496,
		496
	],
	"./ja/discover.json": [
		56134,
		9525
	],
	"./ja/misc.json": [
		57025,
		9951
	],
	"./ja/news.json": [
		22520,
		4032
	],
	"./ja/page.companyReport.dividend.json": [
		5563,
		9687
	],
	"./ja/page.companyReport.future.json": [
		29392,
		8534
	],
	"./ja/page.companyReport.health.json": [
		78085,
		6066
	],
	"./ja/page.companyReport.information.json": [
		42403,
		3516
	],
	"./ja/page.companyReport.json": [
		58343,
		1297
	],
	"./ja/page.companyReport.management.json": [
		59864,
		1084
	],
	"./ja/page.companyReport.overview.json": [
		4516,
		8875
	],
	"./ja/page.companyReport.ownership.json": [
		16474,
		3229
	],
	"./ja/page.companyReport.past.json": [
		27222,
		1029
	],
	"./ja/page.companyReport.valuation.json": [
		33253,
		8698
	],
	"./ja/page.discover.json": [
		79524,
		9525
	],
	"./ja/page.stocks.json": [
		30045,
		9525
	],
	"./ja/statementGlossary.json": [
		37309,
		123
	],
	"./ja/web.json": [
		50496,
		7030
	],
	"./ko/discover.json": [
		21963,
		9525
	],
	"./ko/misc.json": [
		40214,
		9951
	],
	"./ko/news.json": [
		76487,
		3907
	],
	"./ko/page.companyReport.dividend.json": [
		70628,
		9687
	],
	"./ko/page.companyReport.future.json": [
		51397,
		8534
	],
	"./ko/page.companyReport.health.json": [
		63443,
		6066
	],
	"./ko/page.companyReport.information.json": [
		49519,
		3516
	],
	"./ko/page.companyReport.json": [
		29046,
		8297
	],
	"./ko/page.companyReport.management.json": [
		19310,
		1084
	],
	"./ko/page.companyReport.overview.json": [
		51230,
		8875
	],
	"./ko/page.companyReport.ownership.json": [
		19633,
		3229
	],
	"./ko/page.companyReport.past.json": [
		49150,
		1029
	],
	"./ko/page.companyReport.valuation.json": [
		56678,
		8698
	],
	"./ko/page.discover.json": [
		47164,
		9525
	],
	"./ko/page.stocks.json": [
		52894,
		9525
	],
	"./ko/statementGlossary.json": [
		62786,
		5964
	],
	"./ko/web.json": [
		3344,
		9896
	],
	"./nl/discover.json": [
		25705,
		9525
	],
	"./nl/misc.json": [
		54357,
		9951
	],
	"./nl/news.json": [
		7071,
		576
	],
	"./nl/page.companyReport.dividend.json": [
		78893,
		9687
	],
	"./nl/page.companyReport.future.json": [
		27005,
		8534
	],
	"./nl/page.companyReport.health.json": [
		64556,
		6066
	],
	"./nl/page.companyReport.information.json": [
		34600,
		3516
	],
	"./nl/page.companyReport.json": [
		9251,
		2487
	],
	"./nl/page.companyReport.management.json": [
		51422,
		1084
	],
	"./nl/page.companyReport.overview.json": [
		77537,
		8875
	],
	"./nl/page.companyReport.ownership.json": [
		1606,
		3229
	],
	"./nl/page.companyReport.past.json": [
		53128,
		1029
	],
	"./nl/page.companyReport.valuation.json": [
		74326,
		8698
	],
	"./nl/page.discover.json": [
		42711,
		9525
	],
	"./nl/page.stocks.json": [
		16647,
		9525
	],
	"./nl/statementGlossary.json": [
		1363,
		1363
	],
	"./nl/web.json": [
		68246,
		8246
	],
	"./sv/discover.json": [
		12363,
		9525
	],
	"./sv/misc.json": [
		79972,
		9951
	],
	"./sv/news.json": [
		82861,
		576
	],
	"./sv/page.companyReport.dividend.json": [
		47718,
		9687
	],
	"./sv/page.companyReport.future.json": [
		97151,
		8534
	],
	"./sv/page.companyReport.health.json": [
		99823,
		6066
	],
	"./sv/page.companyReport.information.json": [
		26132,
		3516
	],
	"./sv/page.companyReport.json": [
		56761,
		6577
	],
	"./sv/page.companyReport.management.json": [
		65069,
		1084
	],
	"./sv/page.companyReport.overview.json": [
		35655,
		8875
	],
	"./sv/page.companyReport.ownership.json": [
		71996,
		3229
	],
	"./sv/page.companyReport.past.json": [
		25921,
		1029
	],
	"./sv/page.companyReport.valuation.json": [
		61185,
		8698
	],
	"./sv/page.discover.json": [
		56998,
		9525
	],
	"./sv/page.stocks.json": [
		42299,
		9525
	],
	"./sv/statementGlossary.json": [
		63354,
		3354
	],
	"./sv/web.json": [
		10703,
		703
	],
	"./tr/discover.json": [
		72572,
		9525
	],
	"./tr/misc.json": [
		11537,
		9951
	],
	"./tr/news.json": [
		3696,
		8054
	],
	"./tr/page.companyReport.dividend.json": [
		17243,
		9687
	],
	"./tr/page.companyReport.future.json": [
		40220,
		8534
	],
	"./tr/page.companyReport.health.json": [
		56361,
		6066
	],
	"./tr/page.companyReport.information.json": [
		19279,
		3516
	],
	"./tr/page.companyReport.json": [
		49827,
		4895
	],
	"./tr/page.companyReport.management.json": [
		95434,
		1084
	],
	"./tr/page.companyReport.overview.json": [
		63232,
		8875
	],
	"./tr/page.companyReport.ownership.json": [
		15966,
		3229
	],
	"./tr/page.companyReport.past.json": [
		39642,
		1029
	],
	"./tr/page.companyReport.valuation.json": [
		7102,
		8698
	],
	"./tr/page.discover.json": [
		71332,
		9525
	],
	"./tr/page.stocks.json": [
		27961,
		9525
	],
	"./tr/statementGlossary.json": [
		32237,
		2237
	],
	"./tr/web.json": [
		86696,
		6696
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36350;
module.exports = webpackAsyncContext;